<span [class]="isRowOpen ? 'icon-arrow-up' : 'icon-arrow-down'"></span>
